import { useMemo } from 'react';
import { CustomModal, Button, Typography, Card } from 'seagull';
import { routes } from "../../../../constants";
import { useEventReporter, useStoreActions } from "../../../../contexts";
import { useCopyProposalLink } from "../../../../hooks/useCopyProposalLink";
import { useOpenCopyLinkModal } from "../../../../hooks/useOpenCopyLinkModal/useOpenCopyLinkModal";
import { CelebratoryConfetti } from "./CelebratoryConfetti";
import styles from "./PostAgreementCreation.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const celebratoryWords = ['Kudos', 'Woohoo', 'Hooray', 'Rock On', 'YAY', 'Fantastic', 'Awesome', 'Wonderful', 'Fabulous'];
const getRandomCelebratoryWord = () => celebratoryWords[Math.floor(Math.random() * celebratoryWords.length)];
export function PostAgreementCreation(props) {
  const {
    testId,
    proposalLinks,
    onClose: _onClose,
    name,
    sampleAgreementData
  } = props;
  const {
    openCopyLinkForProposal
  } = useOpenCopyLinkModal();
  const {
    copyNotificationUrl
  } = useCopyProposalLink();
  const {
    reportButtonClick,
    reportToAppcues,
    reportToGtm,
    reportToHeap
  } = useEventReporter();
  const {
    logBI
  } = useStoreActions();
  const celebratoryWord = useMemo(() => getRandomCelebratoryWord(), []);
  const onCopyLink = () => {
    if (!sampleAgreementData) {
      reportButtonClick('post-agreement-creation-copy-link_button');
      logBI(10484);
    } else {
      logBI(11902);
      reportToGtm('button-click', 'vendor-opened-test-agreement-button');
      reportToAppcues('button-click', 'vendor-opened-test-agreement-button');
      reportToHeap('testAgreement', 'click', 'vendor-opened-test-agreement-button');
    }
    if (proposalLinks.additionalRecipients.length > 0) {
      openCopyLinkForProposal({
        recipients: proposalLinks
      });
    } else {
      copyNotificationUrl(proposalLinks.primary.notificationURL);
    }
  };
  return /*#__PURE__*/_jsx(CustomModal, {
    disableFooterPadding: true,
    width: 1080,
    minHeight: 670,
    "data-testid": testId,
    onClose: () => _onClose(),
    footer: /*#__PURE__*/_jsxs(Typography, {
      className: styles.footer,
      children: [/*#__PURE__*/_jsx(Typography, {
        as: "span",
        weight: "normal",
        children: "Did you know?"
      }), ' ', "You can update an agreement! Once approved, you can add new services or make changes to services and terms."]
    }),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.wrapper,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.topSectionWrapper,
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.topSection,
          children: [/*#__PURE__*/_jsx(CelebratoryConfetti, {}), /*#__PURE__*/_jsxs(Typography, {
            variant: "h2",
            weight: "normal",
            "data-testid": "".concat(testId, "-title"),
            children: [celebratoryWord, "! Proposal sent!"]
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "h4",
            "data-testid": "".concat(testId, "-subtitle"),
            children: sampleAgreementData ? "A proposal was emailed to ".concat(sampleAgreementData.email) : "Your proposal was emailed to ".concat(name)
          })]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.cardsWithTitle,
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h3",
          weight: "normal",
          children: "What's next?"
        }), /*#__PURE__*/_jsx("div", {
          className: styles.cards,
          children: [{
            id: 'share',
            header: 'Share',
            body: 'Use a different channel to share this proposal',
            btnText: 'Copy link',
            onClick: onCopyLink
          }, {
            id: 'to-monitor',
            header: 'Monitor',
            body: 'Keep track of the approval process',
            btnText: 'Review progress',
            onClick: () => _onClose(routes.proposalsDashboard)
          }, {
            id: 'to-create',
            header: 'Create another proposal',
            body: 'Ready to send another one? Go for it!',
            btnText: 'Create proposal',
            onClick: () => _onClose(routes.agreementStudio)
          }, {
            id: 'to-dashboard',
            header: 'Back to my dashboard',
            body: 'Go back to your dashboard and continue working',
            btnText: 'Go to dashboard',
            onClick: () => _onClose(routes.vendorDashboard)
          }].map(_ref => {
            let {
              id,
              header,
              body,
              btnText,
              onClick
            } = _ref;
            return /*#__PURE__*/_jsxs(Card, {
              className: styles.actionCard,
              children: [/*#__PURE__*/_jsx(Typography, {
                weight: "normal",
                children: header
              }), /*#__PURE__*/_jsx(Typography, {
                variant: "paragraph2",
                children: body
              }), /*#__PURE__*/_jsx(Button, {
                skin: "primaryOutline",
                "data-testid": "".concat(testId, "-").concat(id),
                onClick: onClick,
                children: btnText
              })]
            }, id);
          })
        })]
      })]
    })
  });
}